import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrGQ: CultureInfo = {
  name: 'fr-GQ',
  displayName: 'français (Guinée équatoriale)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-GQ',
  parent: CultureInfoFr
};
